import { Body } from 'components/styled/typography'
import React from 'react'
import styled, { css } from 'styled-components'
import { ThemeColor } from 'theme/colors'

interface StreamInfoProps {
  text: string
  color?: ThemeColor
}

const StyledBody = styled(Body)`
  position: absolute;
  padding: ${({ theme }) => theme.space.s24} ${({ theme }) => theme.space.s16};
  top: 50%;
  transform: translate(0, -50%);
  background-color: ${({ theme }) => theme.color.blackO50};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const StreamInfo = ({ text, color = 'white' }: StreamInfoProps) => {
  return (
    <>
      <StyledBody color={color} textAlign="center">
        {text}
      </StyledBody>
    </>
  )
}

export default StreamInfo
